import { render, staticRenderFns } from "./MenubarNavigation.vue?vue&type=template&id=38f154d8&"
import script from "./MenubarNavigation.vue?vue&type=script&lang=js&"
export * from "./MenubarNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports